<template>
  <Teleport to="body">
    <div v-show="visible" ref="glow" class="atm-glow" aria-hidden="true"></div>
  </Teleport>
</template>
<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const glow = ref<HTMLElement>();
const route = useRoute();
const suppressRoutes = new Set([
  "Agent 创建议题",
  "参与议题",
  "议题结果",
  "个人资料",
  "我的记录",
  "模型服务",
  "创建偏好",
  "账户安全",
]);
// The cursor aura belongs to the homepage scene only; work surfaces stay quiet.
const visible = computed(() => String(route.name || "") === "首页");

let mx = -100,
  my = -100;

const onMove = (e: PointerEvent) => {
  if (!visible.value) return;
  mx = e.clientX;
  my = e.clientY;
  if (glow.value)
    glow.value.style.transform = `translate3d(${mx - 260}px, ${
      my - 260
    }px, 0)`;
};

onMounted(() => {
  window.addEventListener("pointermove", onMove, { passive: true });
});
onBeforeUnmount(() => {
  window.removeEventListener("pointermove", onMove);
});
</script>
<style scoped>
.atm-glow {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(224, 232, 240, 0.085),
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
  will-change: transform;
}
@media (hover: none) {
  .atm-glow {
    display: none;
  }
}
</style>
